import { Component, OnInit, Renderer2, OnDestroy, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { LoginService } from '../../services/login.service';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { VersionService } from 'src/app/core/services/version.service';
import { MqttService, IMqttServiceOptions } from 'ngx-mqtt';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  hasAuthError = false;
  isLoading = false;
  version = 'development';
  baseUrl = '';

  options = [
    { value: 'cs', label: 'Česky' },
    { value: 'en', label: 'English' },
    { value: 'de', label: 'Deutsch' }
  ];
  selectedOption;

  constructor(
    private renderer: Renderer2,
    private loginService: LoginService,
    private router: Router,
    private translate: TranslateService,
    private versionService: VersionService,
    private mqttService: MqttService,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.baseUrl = baseUrl;
  }

  ngOnInit() {
    this.renderer.removeClass(document.body, 'horizontal-menu');
    this.renderer.removeClass(document.body, 'horizontal-app-menu');
    this.renderer.addClass(document.body, 'login');

    this.versionService.getVersion()
      .subscribe((data) => this.version = data.version);

    //select default language
    const language = localStorage.getItem('language');
    if (language) {
      this.selectedOption = this.options.filter((item) => item.value === language)[0];      
    } else {
      this.selectedOption = this.options[0];
    }
  }

  ngOnDestroy() {
    this.renderer.addClass(document.body, 'horizontal-menu');
    this.renderer.addClass(document.body, 'horizontal-app-menu');
    this.renderer.removeClass(document.body, 'login');
  }

  onChange(item) {
    this.translate.setDefaultLang(item.value);
    localStorage.setItem('language', item.value);
  }

  onLogin(values) {
    this.isLoading = true;
    this.loginService.login(values.login, values.password)
      .subscribe(
        () => {
          this.loginMqtt(values.login, values.password);

          this.router.navigateByUrl('/');
          this.isLoading = false;
        },
        err => {
          console.log('HTTP Error', err);
          this.hasAuthError = true;
          this.isLoading = false;
        }
      );
  }

  loginMqtt(login, password) {
    const url = new URL(this.baseUrl);

    const MQTT_SERVICE_OPTIONS: IMqttServiceOptions = {
      //hostname: 'new-monitoring.vrvs.cz',
      hostname: url.hostname,
      port: 8084,
      path: '/mqtt',
      protocol: 'wss',
      clientId: 'Browser:' + String(Math.random()),
      username: login,
      password: password
    };

    //Connect MQTT service
    this.mqttService.connect(MQTT_SERVICE_OPTIONS);
  }

}
